import React, { Component } from 'react';
import history from '../history';
import AccedanApi from '../api/AccedanApi';

class BaseForBases extends Component {

    constructor(props){
        super(props);
        this.getInterfazCallback = this.getInterfazCallback.bind(this);
        this.loadOnConstructor = this.loadOnConstructor.bind(this);
        this.navigateTo = this.navigateTo.bind(this);
        this.getApi = this.getApi.bind(this);
        this.checkConnection = this.checkConnection.bind(this);
        this.checkConnectionCallback = this.checkConnectionCallback.bind(this);
        this.getUrlParams = this.getUrlParams.bind(this);
        this.goBack = this.goBack.bind(this);
        this.getCommonInterface = this.getCommonInterface.bind(this);
        this.getCommonInterfaceCallback= this.getCommonInterfaceCallback.bind(this);
        this.getTrad = this.getTrad.bind(this);
        this.verState = this.verState.bind(this);
        this.isMobileApp = this.isMobileApp.bind(this);
        this.isSystemAdmin = this.isSystemAdmin.bind(this);
        this.loadOnConstructor();
    }

    isMobileApp(){
        if(window.ReactNativeWebView) return true

        return false
    }

    isSystemAdmin(){
        const localUser = localStorage.getItem('user');
        const user = JSON.parse(localUser) || null;

        return user?._id === "60619d32bbeb5158dc32b444"?true:false
    }

    getCommonInterface(callback){
	const api = this.getApi();
    	api.getCommonInterface(callback);

    }

    getCommonInterfaceCallback(response){
	    if(response.status === 'OK'){
		this.setState(prevState => {
			return {
				...prevState,
				i18n: response.i18n
			}
		});
	    }
    }

	verState(){
		console.log("verState::: ",this.state)
	}

    getTrad(key, domain){
	return this.state.i18n!== undefined?this.getI18n(this.state.i18n, key, domain):'';
    }

    getI18n(i18nArray, key, domain){
	const trad = i18nArray.filter(elem => {
		return (domain === undefined?elem.key === key:elem.key === key && elem.domain === domain)
	});
	return trad.length > 0?trad.pop().value:key;

    }

    checkConnection(){
    	const api = this.getApi();
    	api.validateToken(this.checkConnectionCallback);
    }

    checkConnectionCallback(response){
	if(response.auth === false){
		this.navigateTo('/login');
	}
    }

    loadOnConstructor(){
    }
   
    getInterfazCallback(response){
        if(response && response.token !== undefined){
            localStorage.setItem('token', response.token);
            this.props.setMenu( response.menu);
        }else{
            this.navigateTo("/login", 3000);
        }
    }

    navigateTo(page, time){
        if(time !== undefined){
            setTimeout(history.push.bind(this, page) , time);
        }else{
            history.push(page);
        }
    }

    goBack(){
	history.goBack();
    }

    getApi(){
    	return new AccedanApi();
    }

    getUrlParams(){
    	//Quitamos solo la primera interrogacion
	let paramsString = this.props.location?this.props.location.search.replace(/\?/, ''):window.location.href.split('?')[1];
	const arrParams = paramsString.split('&');
	let returned = {};
	arrParams.forEach((elem, index) => {
		const parts = elem.split('=');
		returned[parts[0]] = parts[1];
	});

	return returned;
    }

    render() {
        return (
            <div>
               {this.props.bodyPage}
            </div>
        )
    }

    formStyle = {
        margin: '20px auto',
        paddingTop: "70px",
        border: '3px solid gray',
        width: '400px',
        height: 'auto',
        textAlign: "center",
        borderRadius:"10px",
        background:"#CCC"
      };

    labelStyle = {
        display:"block",
        width:"100%",
        textAlign: "left",
        marginLeft: "40px"
    };

    inputStyle = {
        padding:"5px",
        marginTop:"5px",
        width: "80%",
        borderRadius: "10px"
    }

    textareaStyle = {
        padding:"5px",
        marginTop:"5px",
        height: "80px",
        width: "80%",
        borderRadius: "10px"
    }
    buttonDivStyle = {
        width:"95%",
        paddingTop:"15px",
        textAlign:"center",
        marginBottom: "20px"
    }

    buttonStyle = {
        padding:"5px",
        borderRadius: "5px",
        background: "#FFF"
    }

    separator = {
        width: "100%",
        height: "40px"
    }
}

export default BaseForBases;
